import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { BeatLoader } from "react-spinners";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const ThemeChart = ({ type, data, chartOptions, loading }) => {
  const defaultOptions = {
    responsive: true,
    animation: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
      },
      subtitle: {
        display: true,
        text: "Custom Chart Subtitle",
      },
    },
    animations: {
      tension: {
        duration: 1000,
        easing: "linear",
        from: 1,
        to: 0,
        loop: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            if (value >= 1000) {
              return `${(value / 1000).toFixed(1)}k`;
            }
            return value;
          },
        },
      },
    },
  };
  const chartData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "",
        data: data,
        fill: true,
        backgroundColor: "#158E10",
        borderColor: "#158E10",
      },
    ],
  };

  const options = chartOptions || defaultOptions;

  const chart = {
    line: (
      <Line
        options={options}
        data={chartData || { labels: [], datasets: [] }}
      />
    ),
  };

  return (
    <div className="wrapper">
      {loading || !data ? (
        <BeatLoader
          size={20}
          color="#158E10"
          className="d-flex justify-content-center align-items-center h-100"
        />
      ) : (
        chart[type]
      )}
    </div>
  );
};

export default ThemeChart;
